import React from 'react'
import {Form, Icon, Input, Checkbox, Radio, Select} from 'antd';

import PatientElectronicText from './Texts/PatientElectronicText';
import SurrogateElectronicText from './Texts/SurrogateElectronicText';
import Signature from "./Signature";

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;

    const showForEmail = !(props.consentMethodType === 'Email' && !props.token);
    const isEmail = props.consentMethodType === 'Email';

    return (
      <div className="form-group">
        <h4>{props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'}</h4>

        <div className="form-group-details">
          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.consentPersonType === 'Surrogate' ? <SurrogateElectronicText {...props} /> :
          <PatientElectronicText {...props} />}

        <p><strong>Server Date (UTC): {props.date || props.consentDate}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        {/* <h4>DOCUMENTATION OF INFORMED CONSENT</h4> */}

        <div style={{ textAlign: 'left' }}>
          {isEmail &&
          <div>
            <h4>Email</h4>
          <Form.Item>
            {props.form.getFieldDecorator('mtl_consent_participant_email', {
              initialValue: props.mtl_consent_participant_email,
              rules: [{required: true, message: 'Veuillez saisir l\'email du participant'}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="Email du participant"/>
            )}
          </Form.Item>
          </div>}

          {props.consentPersonType === 'Patient' && <div>
             <h4>SIGNATURE</h4>

          {showForEmail && <div>
            <p>J’ai pris connaissance du formulaire d’information et de consentement. On m’a expliqué le projet de recherche et le présent formulaire d’information et de consentement. On a répondu à mes questions et on m’a laissé le temps voulu pour prendre une décision. Après réflexion, je consens à participer à ce projet de recherche aux conditions qui y sont énoncées.</p>

            <p>J’autorise l’équipe de recherche à avoir accès à mon dossier médical.</p>
            <Form.Item>
              <label>
                <div className='form-label'>J’autorise le chercheur ou son équipe à informer mon médecin traitant de ma participation à ce projet et à lui transmettre toute information pertinente:</div>
                {props.form.getFieldDecorator('mtl_consent_authorize_investigator', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='true'>
                      Oui
                    </Radio>
                    <br/>
                    <Radio value='false'>
                      Non
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
          </div>
          }

          <Form.Item>
            <label>
              <div className='form-label'>Nom et coordonnées du médecin traitant:</div>
              {props.form.getFieldDecorator('mtl_consent_attending_physician_name_and_contact', {
                initialValue: props.mtl_consent_attending_physician_name_and_contact,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  disabled={props.token}
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Nom et coordonnées du médecin traitant"
                />
              )}
            </label>
          </Form.Item>

          <Form.Item>
            <label>
              <div className='form-label'>Nom (en lettres moulées):</div>
              {props.form.getFieldDecorator('mtl_consent_participant_name', {
                initialValue: props.mtl_consent_participant_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Nom (en lettres moulées)"
                />
              )}
            </label>
          </Form.Item>

          {showForEmail && <Signature fieldName='mtl_consent_participant_signature' label='Signature du/de la participant(e)' form={props.form} /> }
          <hr />
          <br/>
          </div>}

          <h4>SIGNATURE DE LA PERSONNE QUI OBTIENT LE CONSENTEMENT</h4>
          <p>J’ai expliqué au/à la participant(e) le projet de recherche et le présent formulaire d’information et de consentement et j’ai répondu aux questions qu’il/elle m’a posées.</p>

          <Form.Item>
            <label>
              <div className='form-label'>Nom (en lettres moulées):</div>
              {props.form.getFieldDecorator('mtl_consent_investigator_name_1', {
                initialValue: props.mtl_consent_investigator_name_1,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  disabled={props.token}
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Nom (en lettres moulées)"
                />
              )}
            </label>
          </Form.Item>

          {!props.token && <Signature fieldName='mtl_consent_investigator_signature_1' label='Signature de la personne qui obtient le consentement' form={props.form} /> }

          <h4>ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUM</h4>

          <p>Je certifie qu’on a expliqué au/à la participant(e) le présent formulaire d’information et de consentement, que l’on a répondu aux questions que le sujet de recherche avait.</p>
          <p>Je m’engage, avec l’équipe de recherche, à respecter ce qui a été convenu au formulaire d’information et de consentement et à en remettre une copie signée et datée au/à la participant(e).</p>

          {!isEmail && showForEmail && <div>
            <hr />
            <br/>
            <h4>SIGNATURE D’UN TÉMOIN</h4>

            <Form.Item>
              <label>
                <div className='form-label'>J’autorise le chercheur ou son équipe à informer mon médecin traitant de ma participation à ce projet et à lui transmettre toute information pertinente:</div>
                {props.form.getFieldDecorator('mtl_consent_has_witness', {
                  rules: [{
                    initialValue: props.mtl_consent_has_witness || 'false',
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='true'>
                      Oui
                    </Radio>
                    <br/>
                    <Radio value='false'>
                      Non
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

            {props.form.getFieldValue('mtl_consent_has_witness') === 'true' &&
              <div>
                <p>La signature d’un témoin est requise pour les raisons suivantes:</p>

                <Form.Item>
                  <label>
                    {props.form.getFieldDecorator('mtl_consent_witness_reason_1', {
                      initialValue: false,
                      valuePropName: 'checked'
                    })(<Checkbox>Difficulté ou incapacité à lire. La personne (témoin impartial) qui appose sa signature ci-dessous atteste qu’on a lu le formulaire de consentement et qu’on a expliqué précisément le projet au (à la) participant(e), qui semble l’avoir compris.</Checkbox>)}
                  </label>
                </Form.Item>

                <Form.Item>
                  <label>
                    {props.form.getFieldDecorator('mtl_consent_witness_reason_2', {
                      initialValue: false,
                      valuePropName: 'checked'
                    })(<Checkbox>Incompréhension de la langue du formulaire de consentement - La personne qui appose sa signature ci-dessous a fait fonction d’interprète pour le ou la participant(e) au cours du processus visant à obtenir le consentement.</Checkbox>)}
                  </label>
                </Form.Item>



                <Form.Item>
                  <label>
                    <div className='form-label'>Nom (en lettres moulées)</div>
                    {props.form.getFieldDecorator('mtl_consent_witness_name', {
                      initialValue: props.mtl_consent_witness_name,
                      rules: [{
                        required: true,
                        message: 'Required'
                      }],
                    })(
                      <Input
                        prefix={<Icon type="user" style={{color: '#eee'}}/>}
                        placeholder="Nom (en lettres moulées)"
                      />
                    )}
                  </label>
                </Form.Item>

                <Signature fieldName='mtl_consent_witness_signature' label='Signature du témoin' form={props.form} />

                <p><b><u>Veuillez noter:</u></b></p>
                <p>Il faut consigner dans le dossier de recherche du (de la) participant(e), le cas échéant, d’autres renseignements sur l’aide fournie au cours du processus visant à obtenir le consentement.</p>
              </div>
            }

            <h4>APPROBATION PAR LE COMITÉ D’ÉTHIQUE DE LA RECHERCHE</h4>
            <p>Le comité d’éthique de la recherche du CHUM a approuvé le projet et assurera le suivi du projet pour les établissements du réseau de la santé et des services sociaux du Québec participants.</p>
          </div>}


          {props.consentPersonType === 'Surrogate' && <div>
            <h4>SIGNATURE DU REPRÉSENTANT LÉGALEMENT AUTORISÉ</h4>
            <p><b>Signature du représentant légalement autorisé</b></p>
            <p>Àtitre de représentant légalement autorisé, j’ai examiné l’ensemble du formulaire d’information et de consentement. Je reconnais que ce projet de recherche m’a été expliqué, qu’on a répondu à mes questions à ma satisfaction et que j’ai eu assez de temps pour prendre une décision.</p>
            <p>De plus, on m’a informé que si la personne que je représente redevient apte à consentir à ce projet par elle-même, et si sa participation au projet de recherche est toujours en cours, elle sera aussi invitée à signer ce formulaire d’information et de consentement.</p>
            <p>Après réflexion, j’accepte que la personne que je représente participe à ce projet de recherche, conformément aux conditions énoncées ci-dessus. Je recevrai une copie signée et datée de ce formulaire d’information et de consentement.</p>
            <p>J’autorise l’équipe de l’étude de recherche à accéder au dossier médical de la personne que je représente pour les besoins de cette étude.</p>

            {showForEmail && <Form.Item>
              <label>
                <div className='form-label'>(Facultatif) J’autorise le médecin de l’étude à informer le ou les médecins traitants de la personne que je représente qu’elle participe à cette étude:</div>
                {props.form.getFieldDecorator('mtl_consent_study_physician', {
                  rules: [{
                    initialValue: props.mtl_consent_study_physician,
                    required: false
                  }],
                })(
                  <Radio.Group>
                    <Radio value='true'>
                      Oui
                    </Radio>
                    <br/>
                    <Radio value='false'>
                      Non
                    </Radio>
                  </Radio.Group>
                )}
              </label>
              </Form.Item>
            }


            <Form.Item>
              <label>
                <div className='form-label'>Nom du participant /lien avec le représentant:</div>
                {props.form.getFieldDecorator('mtl_consent_representative_name_and_relationship', {
                  initialValue: props.mtl_consent_representative_name_and_relationship,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Nom du participant /lien avec le représentant"
                  />
                )}
              </label>
            </Form.Item>

            <Form.Item>
              <label>
                <div className='form-label'>Nom du représentant:</div>
                {props.form.getFieldDecorator('mtl_consent_representative_name', {
                  initialValue: props.mtl_consent_representative_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Nom du représentant"
                  />
                )}
              </label>
            </Form.Item>

            {showForEmail && <Signature fieldName='mtl_consent_representative_signature' label='Signature' form={props.form} /> }

            <p><b>Signature de la personne obtenant le consentement</b></p>
            <p>J’ai expliqué au représentant légalement autorisé du participant à la recherche l’étude de recherche et les termes du présent formulaire d’information et de consentement et j’ai répondu à toutes ses questions.</p>

            <Form.Item>
              <label>
                <div className='form-label'>Nom de la personne obtenant le consentement:</div>
                {props.form.getFieldDecorator('mtl_consent_investigator_name_2', {
                  initialValue: props.mtl_consent_investigator_name_2,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Nom de la personne obtenant le consentement"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token &&<Signature fieldName='mtl_consent_investigator_signature_2' label='Signature' form={props.form} /> }

            <h4>ENGAGEMENT DU CHERCHEUR RESPONSABLE AU CHUM</h4>
            <p>Je certifie qu’on a expliqué au/à la participant(e) le présent formulaire d’information et de consentement, que l’on a répondu aux questions que le sujet de recherche avait.</p>
            <p>Je m’engage, avec l’équipe de recherche, à respecter ce qui a été convenu au formulaire d’information et de consentement et à en remettre une copie signée et datée au/à la participant(e).</p>

          </div>}

          {showForEmail && <div>
            <Form.Item>
              <label>
                <div className='form-label'>Veuillez cocher la case appropriée pour indiquer votre décision:</div>
                {props.form.getFieldDecorator('mtl_rccf_consent_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='stay_in_study'>
                      Je désire demeurer dans l’étude.
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      Je désire me retirer de l’étude.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
          </div>}

          <hr />
          <br/>

          <Form.Item>
            <label>
              <div className='form-label'>Do you consent to the terms described above?</div>
              {props.form.getFieldDecorator('consent_provided', {
                initialValue: props.consent_provided,
                rules: [{
                  required: true,
                  message: 'Do you consent to the terms described above?'
                }],
              })(
                <Select>
                  <Option value="yes">Yes</Option>
                  <Option value="">No</Option>
                </Select>
              )}
            </label>
          </Form.Item>
          <hr />
          <br/>


          {/* {props.consentMethodType === 'Email' && <Form.Item>
            {props.form.getFieldDecorator('mtl_consent_participant_email', {
              initialValue: props.mtl_consent_participant_email,
              rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="Participant Email"/>
            )}
          </Form.Item>}

          {props.consentPersonType === 'Patient' && showForEmail  && (
            <div>
              <Signature fieldName='sb_dic_research_subject_signature' label='Signature of Participant' form={props.form} />
            </div>
          )}

          {props.consentPersonType === 'Surrogate' && <div>
            <Form.Item>
              <label>
                <div className='form-label'>Substitute Decision-Maker Name</div>
                {props.form.getFieldDecorator('sb_dic_surrogate_name', {
                  initialValue: props.sb_dic_surrogate_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Substitute Decision-Maker Name"
                  />
                )}
              </label>
            </Form.Item>

            <Signature fieldName='sb_dic_surrogate_signature' label='Signature of Substitute Decision-Maker' form={props.form} />
          </div>}

          <div>
            <Form.Item>
              <label>
                <div className='form-label'>Person Conducting the Consent Discussion Name & Role</div>
                {props.form.getFieldDecorator('sb_dic_investigator_name_and_role', {
                  initialValue: props.sb_dic_investigator_name_and_role,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Name & Role"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && <Signature fieldName='sb_dic_investigator_signature' label='Signature of Person Conducting the Consent Discussion' form={props.form} />}
          </div> */}


          {/* {showForEmail && <div>

            <p>The following attestation must be provided if the participant is unable to read or requires an oral translation:</p>
            <p><b>If the participant is assisted during the consent process, please check the relevant box and complete the signature space below:</b></p>

            <Form.Item>
              {props.form.getFieldDecorator('sb_dic_is_interpreter', {
                initialValue: false,
                valuePropName: 'checked',
              })(
                <Checkbox>The person signing below acted as an interpreter, and attests that the study as set out in the consent form was accurately sight translated and/or interpreted, and that interpretation was provided on questions, responses and additional discussion arising from this process.</Checkbox>
              )}
            </Form.Item>


            {props.form.getFieldValue('sb_dic_is_interpreter') && <div>
              <Form.Item>
                <label>
                  <div className='form-label'>Interpreter Name</div>
                  {props.form.getFieldDecorator('sb_dic_interpreter_name', {
                    initialValue: props.sb_dic_interpreter_name,
                    rules: [{
                      required: true,
                      message: 'Required'
                    }],
                  })(
                    <Input
                      prefix={<Icon type="user" style={{color: '#eee'}}/>}
                      placeholder="Interpreter Name"
                    />
                  )}
                </label>
              </Form.Item>

              <Signature fieldName='sb_dic_interpreter_signature' label='Signature of Interpreter' form={props.form} />

              <Form.Item>
                <label>
                  <div className='form-label'>Interpreter Language</div>
                  {props.form.getFieldDecorator('sb_dic_interpreter_language', {
                    initialValue: props.sb_dic_interpreter_language,
                    rules: [{
                      required: true,
                      message: 'Required'
                    }],
                  })(
                    <Input
                      placeholder="Interpreter Language"
                    />
                  )}
                </label>
              </Form.Item>

              <Form.Item>
                {props.form.getFieldDecorator('sb_dic_interpreter_was_read', {
                  initialValue: false,
                  valuePropName: 'checked',
                  rules: [{
                    required: true,
                    transform: value => (value || undefined),
                    type: 'boolean',
                    message: 'Required'
                  }],
                })(
                  <Checkbox>The consent form was read to the participant. The person signing below attests that the study as set out in this form was accurately explained to the participant, and any questions have been answered.</Checkbox>
                )}
              </Form.Item>
            </div>}

            <div>
              <Form.Item>
                <label>
                  <div className='form-label'>Witness Name</div>
                  {props.form.getFieldDecorator('sb_dic_witness_name', {
                    initialValue: props.sb_dic_witness_name,
                    rules: [{
                      required: !props.token,
                      message: 'Required'
                    }],
                  })(
                    <Input
                      prefix={<Icon type="user" style={{color: '#eee'}}/>}
                      placeholder="Witness Name"
                    />
                  )}
                </label>
              </Form.Item>

              <Signature fieldName='sb_dic_witness_signature' label='Signature of Witness' form={props.form} optional={props.token} />

              <Form.Item>
                <label>
                  <div className='form-label'>Relationship to Participant</div>
                  {props.form.getFieldDecorator('sb_dic_witness_relationship', {
                    initialValue: props.sb_dic_witness_relationship,
                    rules: [{
                      required: !props.token,
                      message: 'Required'
                    }],
                  })(
                    <Input
                      placeholder="Relationship to Participant"
                    />
                  )}
                </label>
              </Form.Item>
            </div>
            <br/>
            <br/>

            <h3>DEFERRAL OF CONSENT SUB-STUDY</h3>
            <p>We’d like to ask you a few survey questions about how you feel about this study and having been a part of it. The purpose of the survey is to capture the attitudes and experience of participants/SDMs with the deferral of consent process used in the study. This survey is optional. You do not have to take part in the survey to be a part of the main study.</p>

            <p>Please check the appropriate box to indicate your decision:</p>

            <Form.Item>
              <label>
                <div className='form-label'>Please check the appropriate box to indicate your decision:</div>
                {props.form.getFieldDecorator('sb_dcss_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='yes'>
                      I wish to take part in the survey.
                    </Radio>
                    <br/>
                    <Radio value='no'>
                      I wish NOT to take part in the survey.
                    </Radio>
                    <br/>
                    <Radio value='not_applicable'>
                      Not applicable (site is not participating in the ethics survey)
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

            <Form.Item>
              <label>
                <div className='form-label'>Do you consent to the terms described above?</div>
                {props.form.getFieldDecorator('consent_provided', {
                  initialValue: props.consent_provided,
                  rules: [{
                    required: true,
                    message: 'Do you consent to the terms described above?'
                  }],
                })(
                  <Select>
                    <Option value="yes">Yes</Option>
                    <Option value="">No</Option>
                  </Select>
                )}
              </label>
            </Form.Item>
          </div>} */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeMontreal/Step3aPatient.js